import { render, staticRenderFns } from "./ADashboard.vue?vue&type=template&id=46b73fb6&scoped=true&"
import script from "./ADashboard.vue?vue&type=script&lang=js&"
export * from "./ADashboard.vue?vue&type=script&lang=js&"
import style0 from "./ADashboard.vue?vue&type=style&index=0&id=46b73fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b73fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
